<template>
    <div>
        <div class="alert alert-danger" role="alert" v-if="status.length > 0">
            <icon name="exclamation-circle" class="icon"></icon>
            <span class="icon-label icon-label__default">
                The following services are currently down:
                <i
                    v-for="(item, index) in status"
                    v-bind:key="index"
                >
                    {{item}}
                    <span v-if="index+1 < status.length">,</span>
                </i>. See below for more information.
            </span>
        </div>
        <div class="alert alert-success" role="alert" v-else>
            <icon name="check-circle-o" class="icon"></icon>
            <span class="icon-label__default">Celtra is up and running.</span>
        </div>

        <div class="component" v-for="component in components" v-bind:key="component.id">
            <h2>
                <router-link :to="`list/${component.name.toLowerCase()}`">{{component.name}}</router-link>
                <br />
                <small>{{component.description}}</small>
            </h2>

            <div class="incidents" v-for="incident in component.incidents" v-bind:key="incident.id">
                <div class="incident">
                    <h4 class="title">
                        <icon
                            name="info"
                            class="text-info icon"
                            title="Component is up."
                            v-if="incident.componentDown"
                        ></icon>
                        <icon
                            name="exclamation-triangle"
                            class="text-danger icon"
                            title="Component is down."
                            v-else
                        ></icon>
                        <router-link :to="`/incidents/${incident.id}`">
                            <span
                                class="icon-label icon-label__default"
                            >{{ getIncidentStartDate(incident) | date }}</span>
                        </router-link>

                        <div class="pull-right" v-if="isAuthenticated">
                            <span class="edit">
                                <router-link :to="`/incidents/${incident.id}/edit`">
                                    <icon name="edit" class="icon" title="Edit"></icon>
                                    <small class="icon-label">Edit</small>
                                </router-link>
                            </span>
                            <span class="delete" @click.prevent="confirmDelete(incident.id)">
                                <icon name="remove" class="icon" title="Delete"></icon>
                                <small class="icon-label">Delete</small>
                            </span>
                        </div>
                    </h4>
                    <blockquote
                        class="blockquote"
                        v-for="message in incident.messages"
                        v-bind:key="message.id"
                    >
                        <p
                            class="mb-0"
                            v-for="line in message.body.split(/\r?\n/)"
                            v-bind:key="line"
                        >
                            {{ line }}<br/>
                        </p>
                        <footer
                            class="blockquote-footer"
                        >Posted on {{ message.postedAt | date }} at {{ message.postedAt | time }} UTC</footer>
                    </blockquote>
                </div>
            </div>

            <div v-if="component.incidents.length == 0">
                <div
                    class="alert alert-info"
                    role="alert"
                >No incidents or updates in the last 7 days.</div>
            </div>
        </div>
        <confirm-dialog
            :is-visible="isDeleteDialogVisible"
            :message="dialogMessage"
            dialog-action="Delete"
            v-on:close="onCofirmDialog"
        ></confirm-dialog>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import ConfirmDialog from "./ConfirmDialog.vue"
import { NotificationsMixin } from "./mixin"
import store from "../store"

export default {
    name: "Index",
    mixins: [NotificationsMixin],
    components: {
        confirmDialog: ConfirmDialog
    },
    data() {
        return {
            isDeleteDialogVisible: false,
            dialogMessage:
                "Deleting incident will also remove all related messages!",
            deleteIncidentId: null
        }
    },
    computed: {
        ...mapGetters({
            status: "getStatus",
            isAuthenticated: "isAuthenticated",
            components: "getLatestIncidents"
        })
    },
    methods: {
        ...mapActions({
            deleteIncident: "deleteIncident",
            loadLatestIncidents: "loadLatestIncidents"
        }),
        confirmDelete(incidentId) {
            this.deleteIncidentId = incidentId
            this.isDeleteDialogVisible = !this.isDeleteDialogVisible
        },
        onCofirmDialog(isConfirmed) {
            this.isDeleteDialogVisible = !this.isDeleteDialogVisible
            if (isConfirmed) {
                this.deleteIncident(this.deleteIncidentId).then(
                    response => {
                        this.showSuccessMsg({
                            title: "Success.",
                            message: response
                        })
                        this.loadLatestIncidents()
                    },
                    error => {
                        this.showErrorMsg({
                            title: "Error deleting incident!",
                            message: error
                        })
                    }
                )
            }

            this.deleteIncidentId = null
        },
        getIncidentStartDate(incident) {
            if (incident.startDate) {
                return incident.startDate
            } else {
                return incident.messages[0].postedAt
            }
        }
    },
    beforeRouteEnter(to, from, next) {
        store.dispatch("loadLatestIncidents").then(res => next())
    }
}
</script>

<style scoped>
.title {
    padding-bottom: 9px;
    margin: 0 0 10px;
    border-bottom: 1px solid #ccc;
}
.icon {
    text-align: center;
}
.edit {
    padding-right: 10px;
}
.delete {
    cursor: pointer;
}
.incidents {
    padding-top: 20px;
}
a:hover {
    text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue